import request from './handler'

const list = async params => {
  const { data } = await request.get('/attendance', { params })
  return data
}
const createAttendance = form => request.post('/attendance', form)
const updateRealizationAttendance = (form, id) => request.put(`/attendance/update-realization?id=${id}`, form)
const listDetail = async params => {
  const { data } = await request.get('/attendance/detail', { params })
  return data
}
const attendanceEmployeeDetail = form => request.post('/attendance/detail', form)
const updateAttendanceEmployeeDetail = (form, id) => request.put(`/attendance/detail?id=${id}`, form)
const getTypeAttendance = () => request.get('/attendance-type')

export default {
  createAttendance,
  attendanceEmployeeDetail,
  updateAttendanceEmployeeDetail,
  updateRealizationAttendance,
  list,
  listDetail,
  getTypeAttendance
}
